import { render, staticRenderFns } from "./CharacteristicInlineBlock.vue?vue&type=template&id=0b592b7b&"
import script from "./CharacteristicInlineBlock.vue?vue&type=script&lang=js&"
export * from "./CharacteristicInlineBlock.vue?vue&type=script&lang=js&"
import style0 from "./CharacteristicInlineBlock.vue?vue&type=style&index=0&id=0b592b7b&prod&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports